import { Card, CardContent, CardHeader, Checkbox, FormControlLabel, Grid, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormCheckbox from "../forms/form-checkbox/FormCheckbox";
import { AccountSettingsV2FormType } from "./AccountSettingsV2Utils";
import { useFormContext } from "react-hook-form";

export default function SummaryListingCard() {

    const { t } = useTranslation();
    const theme = useTheme();


    const {
        //getValues,
        watch,
        //trigger,
        //control,
        //reset,
        setValue,
        //resetField
    } = useFormContext<AccountSettingsV2FormType>();    

       const [
        //selectedSource,
        //email, 
        //authenticationGuid,
        historicalData,
        graph,
        marketingReport,
        plungerAnalysis,
        gaugeSheet,
        dynacard,
        addMemo,
        mapIt

        ] = watch([
        'historicalData',
        'graph',
        'marketingReport',
        'plungerAnalysis',
        'gaugeSheet',
        'dynacard',
        'addMemo',
        'mapIt'
    ]);



    const allChecked = historicalData && graph &&  marketingReport &&
                                                plungerAnalysis && gaugeSheet &&
                                                dynacard && addMemo && mapIt;

    const shortcuts = [historicalData, graph, marketingReport,
                                                plungerAnalysis, gaugeSheet,
                                                dynacard, addMemo, mapIt];

    const indeterminate = !allChecked ? shortcuts.some(o => o) : allChecked ? shortcuts.some(o => !o) : false;


    function onDisplayShortCuts() {
        
        setValue('historicalData', !allChecked, {shouldDirty: true})
        setValue('graph', !allChecked, {shouldDirty: true})
        setValue('marketingReport', !allChecked, {shouldDirty: true})
        setValue('plungerAnalysis', !allChecked, {shouldDirty: true})
        setValue('gaugeSheet', !allChecked, {shouldDirty: true})
        setValue('dynacard', !allChecked, {shouldDirty: true})
        setValue('addMemo', !allChecked, {shouldDirty: true})
        setValue('mapIt', !allChecked, {shouldDirty: true})

    }
    


    return (
        <Card
            raised={true}
            sx={{
                flex: "0 0 auto",
                margin: theme.spacing(1),
                padding: theme.spacing(2),
                marginTop: 4
            }}
        >
        <CardHeader
                sx={{
                    padding: 1
                }}
                //title={userState.user?.displayText}
                title={t('views.summaryListing')}
                 slotProps={{
                     title: {
                        sx: {
                            fontWeight: "bold", 
                        },
                        variant: 'h5', 
                        //marginLeft: 2 
                    }
                 }}
            />            
            <CardContent
                sx={{
                    padding: 1,
                    paddingBottom: theme => `${theme.spacing(1)} !important`
                }}
            >

                <Grid container spacing={0}>

                    <Grid size={{ xs: 12 }} sx={{flexDirection: 'column'}}>


                        {/* <FormCheckbox
                            name="functionIcons"
                            label={t('profile.displayFunctionIcons')}
                            sx={{width: '90%'}}
                            
                        /> */}

                        <FormControlLabel
                            label={t('profile.displayFunctionIcons')}
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    fontWeight: 'bold',
                                    }}}
                            control={
                                <Checkbox 
                                
                                    checked={allChecked} 
                                    indeterminate={indeterminate}
                                    onChange={() => onDisplayShortCuts()} />
                            }
                        />



                        <Stack direction='column' sx={{ml: 3}}>

                        <FormCheckbox
                            name="historicalData"
                            label={t('profile.historicalData')}
                            sx={{width: '90%'}}
                            
                        />
                        <FormCheckbox
                            name="graph"
                            label={t('profile.graphing')}
                            sx={{width: '90%'}}
                            
                        />
                        <FormCheckbox
                            name="marketingReport"
                            label={t('profile.marketingReport')}
                            sx={{width: '90%'}}
                            
                        />
                        <FormCheckbox
                            name="plungerAnalysis"
                            label={t('profile.plungerAnalysis')}
                            sx={{width: '90%'}}
                            
                        />
                        <FormCheckbox
                            name="gaugeSheet"
                            label={t('profile.gaugeSheet')}
                            sx={{width: '90%'}}
                            
                        />
                        <FormCheckbox
                            name="dynacard"
                            label={t('profile.dynacard')}
                            sx={{width: '90%'}}
                            
                        />
                        <FormCheckbox
                            name="addMemo"
                            label={t('profile.addMemo')}
                            sx={{width: '90%'}}
                            
                        />
                        <FormCheckbox
                            name="mapIt"
                            label={t('profile.mapIt')}
                            sx={{width: '90%'}}
                            
                        />
                        </Stack>

    {/* historicalData?: boolean | undefined;
    graph?: boolean | undefined;
    marketingReport?: boolean | undefined;
    plungerAnalysis?: boolean | undefined;
    gaugeSheet?: boolean | undefined;
    dynacard?: boolean | undefined;
    addMemo?: boolean | undefined;
    mapIt?: boolean | undefined; */}



                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <FormCheckbox
                            name="alarmsAtTop"
                            label={t('profile.displayAlarmsTop')}
                            sx={{ width: '90%' }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <FormCheckbox
                            name="outletsFirst"
                            label={t('profile.displayOutletsFirst')}
                            sx={{ width: '90%' }}
                        />
                    </Grid>
                    
                </Grid>

           </CardContent>
        </Card>
   );
}